import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {
  MedicalMorphologyModel
} from "../../../../../../../modules/medical/morphology/api/model/medicalMorphology.model";
import {
  BmiSummaryFieldModule
} from "../../../../../../../modules/medical/medical-record/general-information/api/component/bmi-summary-field/bmi-summary-field.module";
import {
  DateSummaryFieldModule
} from "../../../../../../../modules/core/component/date/date-summary-field/date-summary-field.module";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {
  DialogInput as MorphoDialogInput, DialogResult as MorphoDialogResult,
  MedicalMorphologySaveDialogComponent
} from "../../../../../../../modules/medical/morphology/api/component/medical-morphology-save-dialog/medical-morphology-save-dialog.component";
import {
  MedicalMorphologySaveDialogModule
} from "../../../../../../../modules/medical/morphology/api/component/medical-morphology-save-dialog/medical-morphology-save-dialog.module";
import {IconsModule} from "../../../../../../../../icons.module";
import {
  MedicalMorphologyDeleteService
} from "../../../../../../../modules/medical/morphology/api/service/medicalMorphologyDelete.service";
import {
    CommentSummaryFieldModule
} from "../../../../../../../modules/core/component/comment/comment-summary-field/comment-summary-field.component";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";

@Component({
  selector: 'app-luna-consultation-morphology-item',
  standalone: true,
  imports: [CommonModule, BmiSummaryFieldModule, DateSummaryFieldModule, ItemModule, SummaryFieldModule, ButtonComponent, MedicalMorphologySaveDialogModule, IconsModule, CommentSummaryFieldModule, SummaryModule],
  templateUrl: './consultation-morphology-item.component.html',
  providers: [
    MedicalMorphologyDeleteService
  ]
})
export class ConsultationMorphologyItemComponent {

  @Input() morphology: MedicalMorphologyModel;
  @Input() displayDate = true;

  constructor(private dialogController: DialogController,
              public deleteService: MedicalMorphologyDeleteService) {}

  edit() {
    const input: MorphoDialogInput = {
      id: this.morphology.id,
    };
    const dialog = this.dialogController.open(MedicalMorphologySaveDialogComponent,
        input, {
          title: 'Modifier l\' évolution morphologique',
          width: '95%'
        });
    dialog.afterClosed().toPromise().then((value: MorphoDialogResult) => {
      if (value) {
        this.morphology = value.entity;
      }
    });
  }

}
